export default {"src":"/_next/static/media/amex.2ece61d8.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};